module.exports = __webpack_public_path__ + "img/public-service-pathway.884131e7.jpg";